import React from 'react';
import { CreditCard } from 'lucide-react';
import { Button, EmptyState, Text } from '@relay-towing/ui';

interface PaymentsNotConnectedProps {
  onBack: () => void;
}

/**
 * The company has no card-payment provider connected. It said "Square Not
 * Connected" to every company, including ones taking payments through
 * RoadSync, so it names neither.
 */
const PaymentsNotConnected: React.FC<PaymentsNotConnectedProps> = ({
  onBack,
}) => (
  <div className="min-h-screen bg-background flex flex-col">
    <div className="bg-primary text-primary-foreground px-4 py-4">
      <Text variant="h3" as="h1">
        Collect Payment
      </Text>
    </div>
    <EmptyState
      className="flex-1"
      icon={CreditCard}
      title="Payments not connected"
      description="Your company needs to connect a payment provider to accept payments. Please contact your administrator."
      action={<Button onClick={onBack}>Go Back</Button>}
    />
  </div>
);

export default PaymentsNotConnected;
